export default "__VITE_ASSET__2cb20f56__"